export const OWNER_ACCEPTED_FILE_TYPES = '.pdf, .jpg, .jpeg, .png, .doc, .docx'
